module.exports = __webpack_public_path__ + "static/thumb_up-d06441a7662f39faa9b32fdfff14cffd.svg";